export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Pending"] = "Pending";
    OrderStatus["Confirmed"] = "Confirmed";
    OrderStatus["Fulfilled"] = "Fulfilled";
})(OrderStatus || (OrderStatus = {}));
/** EFKT-MOCK — mirrors datahub's `submitFeedback` W2 types (`datahub/orders/models.ts::FeedbackType`). */
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["Change"] = "CHANGE";
    FeedbackType["Complaint"] = "COMPLAINT";
    FeedbackType["Feedback"] = "FEEDBACK";
})(FeedbackType || (FeedbackType = {}));
